import { render, staticRenderFns } from "./VocuherListPage.vue?vue&type=template&id=4937f4e6&scoped=true&"
import script from "./VocuherListPage.vue?vue&type=script&lang=js&"
export * from "./VocuherListPage.vue?vue&type=script&lang=js&"
import style0 from "./VocuherListPage.vue?vue&type=style&index=0&id=4937f4e6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937f4e6",
  null
  
)

export default component.exports